export class UpdatePatientAddressRequest {
  street?: string;
  addressNumber?: string;
  addressComplement?: string;
  neighborhood?: string;
  zipCode?: string;
  city?: string;
  state?: string;
  phone?: string;
  idPatient: number; 
  idHealthUnit: number; 
}
